import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface RoleGuardProps {
    children: JSX.Element;
    allowedRoles?: string[];
}

export const RoleGuard: React.FC<RoleGuardProps> = ({
    children,
    allowedRoles = ["Admin"],
}) => {
    const { isAuthenticated, hasRole } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!hasRole(allowedRoles)) {
        return <Navigate to="/not-authorized" replace />;
    }

    return children;
};
